import auth from './oauth';

// une fonction qui permet de gerer les beforeRouteEnter
export default function authorization(to, from, next) {
  const accessControl = auth.computeAccessControl(to);
  if (accessControl.isDenied()) {
    // plain denied
    accessControl.denied();
  } else if (accessControl.isPermitted()) {
    if (
      to &&
      to.name !== 'changepassword' &&
      auth.hasRole('CHANGE_MOTDEPASSE')
    ) {
      // force change password
      next({ name: 'changepassword' });
    } else {
      // plain permit
      next();
    }
  } else {
    // user must be logged and role must be checked
    if (auth.logged()) {
      auth.renewAccessToken(() => {
        if (accessControl.isGranted()) {
          next();
        } else {
          // the authorization level is not reached
          accessControl.denied();
        }
      });
    } else {
      auth.requireLogin(to);
    }
  }
}
